<template>

    <div>

        <div
            :class="{modal: true, in: showModal}"
            :style="{ display: showModal ? 'block' : 'none' }"
        >
            <div
                class="modal-dialog modal-dialog-scrollable"
                role="document"
            >

                <div class="modal-content">

                    <div class="modal-header">

                        <slot name="header"></slot>

                        <div class="modal-header-button">
                            <slot name="header-button"></slot>
                        </div>

                        <button class="close" @click="hideModal">
                            <i class="fas fa-times"></i>
                        </button>

                    </div>

                    <div class="modal-body hide-scroll">
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer">
                        <slot
                            name="footer"
                            style="text-align:center ;"
                        ></slot>
                    </div>

                </div>

            </div>
        </div>

        <div :class="{'modal-backdrop': showModal, in: showModal}"></div>

    </div>

</template>

<script>
    export default {
        props: {
            showModal: Boolean,
            openModal: Function,
            hideModal: Function,
        }
    }
</script>


<style>


    .modal-backdrop {
        background-color: rgba(24, 32, 40, 0.94) !important;
    }

    .modal-dialog {
        max-width: 600px;
    }

    .modal-body {
        max-height: 500px;
        overflow-y:scroll;
    }

    .modal-header-button {
        margin-left: auto;
    }

    .modal-header .close {
        margin: -1rem -1rem -1rem 0 !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/layout/Modal.vue